<template>
    <div>
        <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">National Report</li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">National Report</h1>
        <hr>
		<!-- end page-header -->
        <!-- <div class="d-sm-flex align-items-center mb-3">
            <a href="#" class="btn btn-inverse mr-2 text-truncate" id="daterange-filter">
                <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                <span>1 Jun 2019 - 7 Jun 2019</span>
                <b class="caret"></b>
            </a>
            <div class="text-muted f-w-600 mt-2 mt-sm-0">compared to <span id="daterange-prev-date">24 Mar-30 Apr 2019</span></div>
        </div> -->
        <div class="row" style="padding-left:10px">
            <date-range-picker
                ref="picker"
                v-model="dateRange"
                opens="right"
            >   
                <div slot="input" slot-scope="picker" style="min-width: 250px;">
                    <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                    {{ moment(dateRange.startDate).format("DD MMMM YYYY")}} - {{ moment(dateRange.endDate).format("DD MMMM YYYY")}}
                    <b class="caret"></b>
                    
                </div>
                
            </date-range-picker>
            <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div>
        </div>

        <!-- begin dashboard-->
        <div class="row mt-3">
            <div class="col-xl-6">
                <TotalSalesCard></TotalSalesCard>
            </div>
            <div class="col-xl-6 " style="padding-left : 0">
                <div class="row">
                    <div class="col-sm-6">
                        <TotalProductSoldByUnit></TotalProductSoldByUnit>
                    </div>
                    <div class="col-sm-6">
                        <TopSalesByCity></TopSalesByCity>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-xl-4 col-lg-6">
                <TopSalesByDealer></TopSalesByDealer>
            </div>
            <div class="col-xl-8 col-lg-6">
                <TopSalesByUnitsSold></TopSalesByUnitsSold>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-8 col-lg-6">
            </div>
            <div class="col-xl-4 col-lg-6">
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-lg-12">
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-lg-12">
            </div>
        </div>
    </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment';
import * as am4core from "@amcharts/amcharts4/core";

//import child components;
import TotalSalesCard from './childComponents/total-sales-card';
import TotalProductSoldByUnit from './childComponents/total-product-sold-by-unit';
import TopSalesByCity from './childComponents/top-sales-by-city';
import TopSalesByDealer from './childComponents/top-sales-by-dealer';
import TopSalesByUnitsSold from './childComponents/top-products-by-units-sold';



export default {
    components : {
        DateRangePicker,
        TotalSalesCard,
        TotalProductSoldByUnit,
        TopSalesByCity,
        TopSalesByDealer,
        TopSalesByUnitsSold
    },
    beforeDestroy(){
        am4core.disposeAllCharts();
    },
    data(){
        var startDate = moment().startOf('month');
        var compareDate = {
            startDate :  new moment().subtract(1, 'months').date(1),
            endDate : new moment().date(0)
        }

        return{
            moment : moment,
            dateRange: {
                startDate : startDate,
                endDate : new moment()
            },
            comparisonDate : compareDate,
            format: moment.localeData().longDateFormat('L'),
        }
    },
    watch : {
        dateRange : function(){
            var start = new moment(this.dateRange.startDate);
            var end = new moment(this.dateRange.endDate);
            var startDate = start.date();
            var endDate = end.date();

            var startMonth = start.month();
            var endMonth = end.month();

            var diffDate = end.diff(start, 'days');

            if(startDate == 1 && endMonth ==  startMonth && endDate == end.endOf('month').date()){
                this.comparisonDate.startDate = new moment(this.dateRange.startDate).subtract(1 , 'months').date(1);
                this.comparisonDate.endDate =  new moment(this.dateRange.startDate).date(0);
            }
            else{
                this.comparisonDate.endDate = new moment(this.dateRange.startDate).subtract(1 , 'day');
                this.comparisonDate.startDate = new moment(this.dateRange.startDate).subtract(diffDate , 'day');
            }
        }
    }
}
</script>

<style>
    .row{
        margin-left  : 0px !important;
    }
</style>
<style>
    /* .reportrange-text{
        background: #1f2225 !important;
        color : red;
    }
    .reportrange-text:hover{
        color : #fff;
    } */
</style>